import {
    ActionIcon,
    Box,
    Button,
    Center,
    Container,
    Flex,
    Popover,
    ScrollArea,
    Stack,
    Table,
    Text,
    Tooltip,
    useMantineTheme,
} from "@mantine/core";
import {
    IconCheck,
    IconExternalLink,
    IconInfoCircle,
    IconSquareToggle,
    IconToggleLeft,
    IconToggleRight,
} from "@tabler/icons";
import { useSession } from "next-auth/react";
import Link from "next/link";
import { useEffect } from "react";
import { nextYear } from "../../../apps/mn/seo/seoCommon";
import { formatDateAgo } from "../common/commonfunc";

const TestSeriesSyllabus = () => {
    const { data: session, status } = useSession();

    const test_data = [
        {
            id: "mt1",
            name: "Mock Test 1",
            paid: true,
            tags: "Mine Methods, Survey",
            date: 1682967034000,
        },
        {
            id: "mt2",
            name: "Mock Test 2",
            paid: true,
            tags: "Aptitude",
            date: 1690915834000,
        },
        {
            id: "mt3",
            name: "Mock Test 3",
            paid: true,
            tags: "Mine Machinery, Mine Methods, Survey",
            date: 1685645434000,
        },
        {
            id: "gt1",
            name: "Gate Test 1",
            paid: true,
            tags: "Mine Machinery, Rock Mechanics, Economics",
            date: 1688237434000,
        },
        {
            id: "gt2",
            name: "Gate Test 2",
            paid: true,
            tags: "Mining Methods, Ventilation",
            date: 1690915834000,
        },
        {
            id: "gt3",
            name: "Gate Test 3",
            paid: true,
            tags: "Mining Methods, Operation Research, Ventilation",
            date: 1690915834000,
        },
        {
            id: "gst1",
            name: "Subjectwise Test 1",
            paid: true,
            tags: "Ventilation",
            date: 1672599034000,
        },
        {
            id: "gst2",
            name: "Subjectwise Test 2",
            paid: true,
            tags: "Machinery",
            date: 1672599034000,
        },
        {
            id: "gst3",
            name: "Subjectwise Test 3",
            paid: true,
            tags: "Mine Methods",
            date: 1672599034000,
        },
        {
            id: "gst4",
            name: "Subjectwise Test 4",
            paid: true,
            tags: "Rock Mechanics",
            date: 1675277434000,
        },
        {
            id: "gst5",
            name: "Subjectwise Test 5",
            paid: true,
            tags: "Planning",
            date: 1675277434000,
        },
        {
            id: "gst6",
            name: "Subjectwise Test 6",
            paid: true,
            tags: "Survey",
            date: 1675277434000,
        },
        {
            id: "gst7",
            name: "Subjectwise Test 7",
            paid: true,
            tags: "Operation Research",
            date: 1677696634000,
        },
        {
            id: "gst8",
            name: "Subjectwise Test 8",
            paid: true,
            tags: "Economics",
            date: 1677696634000,
        },
        {
            id: "gset1",
            name: "Sectional Test 1",
            paid: true,
            tags: "Aptitude",
            date: 1672599034000,
        },
        {
            id: "gset2",
            name: "Sectional Test 2",
            paid: true,
            tags: "Geology, Development, Survey",
            date: 1677696634000,
        },
        {
            id: "gset3",
            name: "Sectional Test 3",
            paid: true,
            tags: "Rock Mechanics",
            date: 1677696634000,
        },
        {
            id: "gset4",
            name: "Sectional Test 4",
            paid: true,
            tags: "Mining Methods, Machinery",
            date: 1675277434000,
        },
        {
            id: "gset5",
            name: "Sectional Test 5",
            paid: true,
            tags: "Environment, Ventilation, Hazards",
            date: 1680375034000,
        },
        {
            id: "gset6",
            name: "Sectional Test 6",
            paid: true,
            tags: " Economics, Planning, Operation Research",
            date: 1680375034000,
        },
        {
            id: "gmt5",
            name: "Mock Test 5",
            paid: true,
            tags: "Full Syllabus",
            date: 1682967034000,
        },
        {
            id: "gmt6",
            name: "Mock Test 6",
            paid: true,
            tags: "Full Syllabus",
            date: 1685645434000,
        },
        {
            id: "gmt7",
            name: "Mock Test 7",
            paid: true,
            tags: "Full Syllabus",
            date: 1688237434000,
        },
        {
            id: "gmt8",
            name: "Mock Test 8",
            paid: true,
            tags: "Full Syllabus",
            date: 1688237434000,
        },
        {
            id: "gap1",
            name: "Aptitude Test 1",
            paid: true,
            tags: "Linear Algebra, Calculus",
            date: 1682967034000,
        },
        {
            id: "gap2",
            name: "Aptitude Test 2",
            paid: true,
            tags: "Calculus, Vector Calculus",
            date: 1682967034000,
        },
        {
            id: "gap3",
            name: "Aptitude Test 3",
            paid: true,
            tags: "Differential Equations",
            date: 1685645434000,
        },
        {
            id: "gap4",
            name: "Aptitude Test 4",
            paid: true,
            tags: "Probability and Statistics",
            date: 1685645434000,
        },
        {
            id: "gap5",
            name: "Aptitude Test 5",
            paid: true,
            tags: "Numerical Methods",
            date: 1688237434000,
        },
        {
            id: "gspet1",
            name: "Special Aptitude Test 1",
            paid: true,
            tags: "Full Syllabus Aptitude",
            date: 1698864634000,
        },
        {
            id: "gspet2",
            name: "Special Subject Test 2",
            paid: true,
            tags: "Technical",
            date: 1698864634000,
        },
        {
            id: "gspet3",
            name: "Special Test 3",
            paid: true,
            tags: "Full Syllabus",
            date: 1698864634000,
        },
    ];
    let now = Date.now();

    const theme = useMantineTheme();
    const rows = test_data.map((test) => {
        let label = `This test ${
            now < test.date ? "is activating" : "has activated"
        } ${formatDateAgo(test.date)}`;
        return (
            <tr key={test.id}>
                <td>{test.id.toUpperCase()}</td>
                <td>{test.name}</td>
                <td>{test.tags}</td>
                <td>
                    <Tooltip label={label}>
                        <Flex gap={10} align={"center"}>
                            {now >= test.date && (
                                <IconToggleLeft color={theme.colors.green[5]} />
                            )}
                            {now < test.date && (
                                <IconToggleRight color={theme.colors.red[5]} />
                            )}
                            <Stack spacing={0} sx={{ alignSelf: "start" }}>
                                <Text component="p" m={0}>
                                    {formatDateAgo(test.date)}
                                </Text>
                                {!!session && session.info.usertype == "admin" && (
                                    <Box>
                                        <Text component="p" m={0}>
                                            {test.date}
                                        </Text>
                                        <Text component="p" m={0}>
                                            {
                                                new Date(test.date)
                                                    .toISOString()
                                                    .split("T")[0]
                                            }
                                        </Text>
                                    </Box>
                                )}
                            </Stack>
                            <Popover
                                width={200}
                                position="bottom"
                                withArrow
                                shadow="md"
                            >
                                <Popover.Target>
                                    <ActionIcon
                                        color="indigo"
                                        radius="xl"
                                        variant="light"
                                    >
                                        <IconInfoCircle size={18} />
                                    </ActionIcon>
                                </Popover.Target>
                                <Popover.Dropdown>
                                    <Text size="sm">{label}</Text>
                                </Popover.Dropdown>
                            </Popover>
                        </Flex>
                    </Tooltip>
                </td>
            </tr>
        );
    });

    return (
        <Container>
            <ScrollArea>
                <Box miw={800}>
                    <Flex>
                        <Text component="h1" fz={"1.5rem"}>
                            MTS Syllabus {nextYear}
                        </Text>
                        <Link
                            href={"/syllabus/mts"}
                            style={{ alignSelf: "start" }}
                        >
                            <ActionIcon>
                                <IconExternalLink size={20} />
                            </ActionIcon>
                        </Link>
                    </Flex>
                    <Text c="dimmed" italic fz={"sm"}>
                        MTS Syllabus for GATE {nextYear + 1} and {nextYear + 2}{" "}
                        aspirants will be the same and additional tests will be
                        activated automatically*
                    </Text>
                    <Table fontSize="md" striped highlightOnHover>
                        <thead>
                            <tr>
                                <th>Test ID</th>
                                <th>Test name</th>
                                <th>Syllabus</th>
                                <th>Activation</th>
                            </tr>
                        </thead>
                        <tbody>{rows}</tbody>
                    </Table>
                </Box>
            </ScrollArea>
        </Container>
    );
};

export default TestSeriesSyllabus;
